import React from 'react';
import { getModalStyles, injectModalAnimations } from './Modal_style.js';

const Modal = ({ isOpen, onClose, title, children }) => {
    const [isClosing, setIsClosing] = React.useState(false);
    const [isHoveringClose, setIsHoveringClose] = React.useState(false);
    const styles = getModalStyles();
    const handleBackdropClick = (e) => {
        // Close modal if clicking the backdrop (not the modal content)
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    const handleEscapeKey = (e) => {
        if (e.key === 'Escape') {
            handleClose();
        }
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsClosing(false);
            onClose();
        }, 250); // Match CSS animation duration
    };

    // Add escape key listener when modal opens - must be called before conditional return
    React.useEffect(() => {
        // Inject animations on first load
        injectModalAnimations();
        
        if (isOpen) {
            document.addEventListener('keydown', handleEscapeKey);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, handleEscapeKey]);

    if (!isOpen && !isClosing) return null;

    return (
        <div 
            style={{
                ...styles.overlay,
                ...(isClosing ? { animation: 'modalFadeOut 0.15s ease-out forwards' } : { animation: 'modalFadeIn 0.3s ease-out' })
            }} 
            onClick={handleBackdropClick}
        >
            <div 
                style={{
                    ...styles.content,
                    ...(isClosing ? { animation: 'modalSlideOut 0.15s ease-out forwards' } : { animation: 'modalSlideIn 0.3s ease-out' })
                }}
            >
                <div style={styles.header}>
                    {title && <h2 style={styles.title}>{title}</h2>}
                    <button 
                        style={{
                            ...styles.closeButton,
                            ...(isHoveringClose ? { background: 'rgba(64, 230, 202, 0.1)', color: '#C19BD1', transform: 'scale(1.1)' } : {})
                        }}
                        onClick={handleClose}
                        onMouseEnter={() => setIsHoveringClose(true)}
                        onMouseLeave={() => setIsHoveringClose(false)}
                    >
                        ×
                    </button>
                </div>
                <div style={styles.body}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;